import React, { useEffect, useRef, useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Api } from '../../services/api';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'primereact/button';
import { TabPanel, TabView } from 'primereact/tabview';
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode, FilterOperator } from "primereact/api";



const FormDashboard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isReminderBoxOpen, setIsReminderBoxOpen] = useState(false);
    const toast = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    // const [formList, setFormList] = useState(true);
    const [formList, setFormList] = useState([]);
    const [archiveFormList, setArchiveFormList] = useState(true);

    const [activeIndex, setActiveIndex] = useState(0);

    const [selectedProduct, setSelectedProduct] = useState(null);


    //! ----------------
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [conversationId, setConversationId] = useState(null);
    const [conversationType, setConversationType] = useState(null);


    const [reason, setReason] = useState('');
    const [quarterForReminder, setQuarterForReminder] = useState('');
    const [yearForReminder, setYearForReminder] = useState('');
    const [reminderReason, setReminderReason] = useState('');

    const [projectDeletetitle, setProjectDeleteTitle] = useState('Are you sure you want to Archive this project?');
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] =
        useState(false);


    const [roleId, setRoleId] = useState(null);
    const [teamMemberList, setTeamMemberList] = useState([]);
    const [selectedTeamMember, setSelectedTeamMember] = useState(null);
    const [reminderBoxError, setReminderBoxError] = useState('');

    //! ----------------

     //* ----------------
    /** search Filtter function Start */

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        team_member_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        supervisor_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        quater: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        year: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
    });
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            team_member_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            supervisor_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            quater: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            year: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
        });
        setGlobalFilterValue('');
    };

    /** search Filtter function End */
    //! ----------------



    const openEditModal = (event) => {
        // navigate('/form/' + event.id)
        localStorage.setItem('quarterlyHuddleConRedirect', JSON.stringify({
            rows: rows,
            first: first,
            sortField: sortField,
            sortOrder: sortOrder,

        }))

        localStorage.setItem('quarterlyHuddleConSelectedProduct', JSON.stringify(event))


        // navigate('/form/' + event.slug)

        navigate('/form/' + event.slug)
    };



    const reminderBox = (rowData) => {
        setReminderBoxError('');
        setQuarterForReminder('');
        setYearForReminder('');
        setReminderReason('');
        setSelectedTeamMember(null);
        setIsReminderBoxOpen(true);
    };

    useEffect(() => {
        // Fetch form data here...
        if (location.state?.selectedId) {
            // Automatically select the row with the passed identifier
            const selectedId = location.state.selectedId;
            const selectedForm = formList.find(form => form.id === selectedId);
            setSelectedProduct(selectedForm);
        }
    }, [location.state, formList]);

    useEffect(() => {
        console.log('Fetching projects...');
        getFormData();
        const storedRoleId = localStorage.getItem('role_id');
        setRoleId(storedRoleId);
        console.log('role_id', storedRoleId);
        initFilters();
    }, []);



    const getFormData = async () => {

        var user_id = localStorage.getItem('user_id');
        // var roll_id = localStorage.getItem('roll_id');

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };


        var _body = {
            user_id: user_id,

        }

        fetch(Api.API_BASE_URL + '555/get-all', {
            method: 'POST',
            body: JSON.stringify(_body),
            headers: headers,

        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                console.log(response)
                if (response.error != '') {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.error, life: 3000 });
                } else {
                    // setFormList(response.result)
                    // setArchiveFormList(response.archive)
                    // setTeamMemberList(response.teamMember)
                    // console.log('ksksksks', response.teamMember)
                     // *-------Suraj Code for Shorting-----------
                     setFormList(response.result.sort((a, b) => new Date(b.date) - new Date(a.date)));
                     setArchiveFormList(response.archive.sort((a, b) => new Date(b.date) - new Date(a.date)));
                     setTeamMemberList(response.teamMember);
 
                     console.log('setFilters---------->',setFilters)
                     // !-------Suraj Code for Shorting-----------

                    //* --------------------------
                    let playbookRedirect = localStorage.getItem('quarterlyHuddleConRedirect');
                    if (playbookRedirect) {
                        playbookRedirect = JSON.parse(playbookRedirect)
                        setFirst(playbookRedirect.first || 0)
                        setRows(playbookRedirect.rows || 12)
                        setSortField(playbookRedirect.sortField || 'quater')
                        setSortOrder(playbookRedirect.sortOrder || -1)

                    }
                    let playbookSelectedProduct = localStorage.getItem('quarterlyHuddleConSelectedProduct');


                    if (playbookSelectedProduct) {
                        playbookSelectedProduct = JSON.parse(playbookSelectedProduct)
                        setSelectedRowData(playbookSelectedProduct)
                    }

                    localStorage.removeItem('quarterlyHuddleConSelectedProduct')
                    localStorage.removeItem('quarterlyHuddleConRedirect');
                    //! --------------------------
                }
            })
            // .then((response) => console.log('ksksksks', response))
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        console.log({
            supervisor_name: selectedRowData.supervisor_name,
            status: 'Request',
            reason: reason
        });


        var userId = localStorage.getItem('user_id');

        fetch(Api.API_BASE_URL + '555/request', {
            method: 'POST',

            body: JSON.stringify({

                userId: userId,
                conversationId: conversationId,
                conversationType: conversationType,
                reason: reason,
            }),
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response data
                console.log('Success:', data);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Form submitted successfully', life: 3000 });
                setIsModalOpen(false);
            })
            .catch((error) => {
                console.error('Error:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Form submission failed', life: 3000 });
            });
    };

    const handleReminderSubmit = (e) => {
        e.preventDefault();


        var user_id = localStorage.getItem('user_id');

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };
        fetch(Api.API_BASE_URL + '555/notify-for-all', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({

                user_id: user_id,
                year: yearForReminder,
                quarter: quarterForReminder,
                team_member: selectedTeamMember,
                // conversationId: conversationId,
                // conversationType: conversationType,
                reason: reminderReason,
            }),
        })
            .then(response => response.json())
            .then(data => {
                // Handle the response data
                console.log('Success:', data);
                if (data.error != '') {
                    setReminderBoxError(data.error);
                    // toast.current.show({ severity: 'error', summary: 'Error', detail: data.error, life: 3000});
                } else {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Form submitted successfully', life: 3000 });
                    setIsReminderBoxOpen(false);
                    getFormData();
                    setReminderBoxError('');
                }

                // ----------Reload -----------
            })
            .catch((error) => {
                console.error('Error:', error);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Form submission failed', life: 3000 });
            });
    };

    // ---------------------------------------------------------------------------------
  
    

    const header = (
        <div className="flex flex-wrap align-items-center justify-content-end m-2">
             <span className="flex-grow p-input-icon-left" style={{ order: 1 }}>
                <InputText
                    className="input-field m-2"
                    type="search"
                    placeholder="Search..."
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                />
            </span>
        </div>
    );

    const onRowSelect = (e) => {
        const rowData = e.data;
        openEditModal(rowData);
        setSelectedRowData(rowData);
    };

    const handleDeleteProject = (projectId,) => {
        // setDeleteContract('Archive');

        // setProjectDelete('project');
        setProjectDeleteTitle('Are you sure you want to Archive this project?');
        // setProjectIdToDelete(projectId);
        setIsDeleteConfirmationModalOpen(true);
        setConversationId(projectId);
    };

    const confirmDelete = async () => {
        var user_id = localStorage.getItem('user_id');

        var _body = {
            user_id: user_id,
            // userId: userId,
            conversationId: conversationId,
        }

        fetch(Api.API_BASE_URL + '555/status-update', {
            method: 'POST',
            body: JSON.stringify(_body),

        })
            .then((response) => response.json())
            .then((response) => {
                setIsLoading(false);
                console.log(response)
                if (response.error != '') {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: response.error, life: 3000 });
                } else {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Form deleted successfully', life: 3000 });
                    getFormData();
                    setIsDeleteConfirmationModalOpen(false);
                }
            })
    }




    const renderSelectForQuarter = () => {

        return <select
            required
            name='quarter'
            id='quarter'
            // className={'select-text-color-' + val}
            value={quarterForReminder}
            onChange={(e) => {
                setQuarterForReminder(e.target.value);
            }}
            style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '16px', color: 'Black', backgroundColor: '#EEEEEE', border: 'none' }}
        >
            <option selected disabled value=""></option>
            <option value="Q1">Quarter-1</option>
            <option value="Q2">Quarter-2</option>
            <option value="Q3">Quarter-3</option>
            <option value="Q4">Quarter-4</option>
        </select>
    };
    const renderYearSelect = () => {

        // Create an array of years from 2020 to 2030
        const years = [];
        for (let year = 2020; year <= 2030; year++) {
            years.push(year);
        }

        return (
            <select
                required
                name='year'
                id='year'
                value={yearForReminder}

                onChange={(e) => {
                    setYearForReminder(e.target.value);
                }}
                style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '16px', color: 'Black', font: 'bold', backgroundColor: '#EEEEEE', border: 'none' }}
            >

                <option selected disabled value=''></option>
                {years.map(year => (
                    <option key={year} value={year}>{year}</option>
                ))}
            </select>
        );
    };

    const renderTeamMemberSelect = () => {

        return (
            <MultiSelect value={selectedTeamMember} onChange={(e) => setSelectedTeamMember(e.value)} options={teamMemberList} optionLabel={(e) => { return e.first_name + ' ' + e.last_name }} required className='text-center align-items-center'
                placeholder="Select Team Member" maxSelectedLabels={3} optionValue='id' style={{ width: '100%', textAlign: 'center', height: "40px", fontSize: '16px', color: 'Black', backgroundColor: '#EEEEEE', border: 'none', }} />

        );
    };

    //! -------------------------
    //  const closeModal = () => {
    //     setIsModalOpen(false);
    //     setIsDeleteConfirmationModalOpen(false);
    // };


    //! ---------------

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
        // setIsResendEmailModalOpen(false);
    };

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(12);
    const [sortField, setSortField] = useState('quater');
    const [sortOrder, setSortOrder] = useState(-1);
    const fetchData = async (event) => {
        const { first, rows, sortField, sortOrder } = event;
        setFirst(first);
        setRows(rows);
        setSortField(sortField);
        setSortOrder(sortOrder);
    }
    //* ---------------


    return (
        <>
            {/* // -------------------------------------------------------------------------------------- */}
            <div style={{ textAlign: "end", padding: "10px 10px 0" }}>

                <Button type="button" title='Send Huddle Conversation' className="customSave-button mr-4" onClick={reminderBox}>
                Send Huddle Conversation
                </Button>
            </div>
            {/* // -------------------------------------------------------------------------------------- */}
            <div className="pagee-container">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                            <TabPanel header="Active" className="p-2 pb-2" >
                                <DataTable
                                    value={formList}
                                    paginator

                                    rows={rows}
                                    first={first}
                                    sortField={sortField}
                                    sortOrder={sortOrder}
                                    onPage={fetchData}
                                    onSort={fetchData}

                                    // key="id"
                                    tableStyle={{ minWidth: '50rem' }}
                                    selectionMode="single"
                                    onRowSelect={onRowSelect}
                                    onRowUnselect={onRowSelect}

                                    selection={selectedRowData}
                                    // onSelectionChange={(e) => setSelectedProduct(e.value)}
                                    header={header}

                                    filters={filters}
                                    filterDisplay="menu"
                                    globalFilterFields={['team_member_name', 'supervisor_name', 'date', 'quater', 'year']}
                                    emptyMessage="No records found"
                                >
                                   

                                   <Column field="team_member_name" sortable header="User" className="col-padding" ></Column>
                                   <Column field="supervisor_name" sortable header="Supervisor Name" className="col-padding" ></Column>
                                   <Column field="date" sortable header="Date" className="col-padding"></Column>

                                   <Column field="quater" sortable header="Quarter" body={(e) => {
                                        let quarterText = '';
                                        let backgroundColor = '';
                                        switch (e.quater) {
                                            case 'Q1':
                                                quarterText = 'Quarter 1';
                                                backgroundColor = '#FF6384';
                                                break;
                                            case 'Q2':
                                                quarterText = 'Quarter 2';
                                                backgroundColor = '#36A2EB';
                                                break;
                                            case 'Q3':
                                                quarterText = 'Quarter 3';
                                                backgroundColor = '#FFCE56';
                                                break;
                                            case 'Q4':
                                                quarterText = 'Quarter 4';
                                                backgroundColor = '#4BC0C0';
                                                break;
                                            default:
                                                quarterText = '';
                                                backgroundColor = 'transparent';
                                        }
                                        return <span style={{ backgroundColor, padding: '4px 8px', borderRadius: '4px', color: backgroundColor === '#FFCE56' ? 'white' : 'white' }}>{quarterText}</span>;
                                    }}
                                        style={{ textAlign: 'center' }}
                                    ></Column>

                                    <Column field="year" sortable header="Year" className="col-padding"></Column>
                                    <Column field="created_at" header="Created At" className="col-padding"></Column>
                                    <Column field="created_by" header="Created By" className="col-padding"></Column>
                                    <Column field="modify_at" header="Modified At" className="col-padding"></Column>
                                    <Column field="modify_by" header="Modified By" className="col-padding"></Column>

                                </DataTable>
                            </TabPanel>


                            <TabPanel header="Archive" className="p-2 pb-2" >
                                <DataTable
                                    value={archiveFormList}
                                    paginator

                                    rows={rows}
                                    first={first}
                                    sortField={sortField}
                                    sortOrder={sortOrder}
                                    onPage={fetchData}
                                    onSort={fetchData}
                                   
                                   
                                    tableStyle={{ minWidth: '50rem' }}
                                    selectionMode="single"
                                    onRowSelect={onRowSelect}
                                    onRowUnselect={onRowSelect}

                                    selection={selectedRowData}

                                    header={header}

                                    filters={filters}
                                    filterDisplay="menu"
                                    globalFilterFields={['team_member_name', 'supervisor_name', 'date', 'quater', 'year']}
                                    emptyMessage="No records found"
                                >
                                   
                                    <Column field="team_member_name" sortable header="User" className="col-padding" ></Column>
                                    <Column field="supervisor_name" sortable header="Supervisor Name" className="col-padding" ></Column>
                                   
                                    <Column field="date" sortable header="Date" className="col-padding"></Column>
                                   
                                    <Column field="quater" sortable header="Quarter" body={(e) => {
                                        let quarterText = '';
                                        let backgroundColor = '';
                                        switch (e.quater) {
                                            case 'Q1':
                                                quarterText = 'Quarter 1';
                                                backgroundColor = '#FF6384';
                                                break;
                                            case 'Q2':
                                                quarterText = 'Quarter 2';
                                                backgroundColor = '#36A2EB';
                                                break;
                                            case 'Q3':
                                                quarterText = 'Quarter 3';
                                                backgroundColor = '#FFCE56';
                                                break;
                                            case 'Q4':
                                                quarterText = 'Quarter 4';
                                                backgroundColor = '#4BC0C0';
                                                break;
                                            default:
                                                quarterText = '';
                                                backgroundColor = 'transparent';
                                        }
                                        return <span style={{ backgroundColor, padding: '4px 8px', borderRadius: '4px', color: backgroundColor === '#FFCE56' ? 'white' : 'white' }}>{quarterText}</span>;
                                    }}
                                        style={{ textAlign: 'center' }}
                                    ></Column>
                                    <Column field="year" sortable header="Year" className="col-padding"></Column>
                                    <Column field="created_at" header="Created At" className="col-padding"></Column>
                                    <Column field="created_by" header="Created By" className="col-padding"></Column>
                                    <Column field="modify_at" header="Modified At" className="col-padding"></Column>
                                    <Column field="modify_by" header="Modified By" className="col-padding"></Column>


                                </DataTable>
                            </TabPanel>
                        </TabView>
                    )}
                </div>
            </div>

            {/* // --------------------------------dialog Box------------------------------------------------------ */}

            <Dialog header="" visible={isModalOpen} style={{ width: '50vw' }} dismissableMask="true" onHide={() => setIsModalOpen(false)}>

                {selectedRowData && (
                    <div className=''>
                        <form onSubmit={handleSubmit} className="" >
                            <div className=" formgrid grid">
                                <div className="col-6 pt-2">
                                    <p>Supervisor Name: <strong className='text-xl'> {selectedRowData.supervisor_name} </strong></p>
                                </div>

                                <div className="col-12 pt-2">
                                    <label htmlFor="reason">Reason</label>
                                    <textarea
                                        id="reason"
                                        value={reason}
                                        onChange={(e) => setReason(e.target.value)}
                                        className="p-inputtext p-component"
                                        style={{ width: '100%', height: '100px' }}
                                    />
                                </div>

                                <div className="card flex flex-wrap justify-content-center gap-3">
                                    <Button label="Submit" type="submit" className="p-2" />
                                </div>

                            </div>
                        </form>
                    </div>
                )}
            </Dialog>

            {/* // --------------------------------Reminder Box------------------------------- */}
            <Dialog header="" visible={isReminderBoxOpen} style={{ width: '50vw', overflow: 'hidden' }} dismissableMask="true" onHide={() => setIsReminderBoxOpen(false)}>

                <div className='p-2' style={{ overflow: 'hidden' }}>
                    <form onSubmit={handleReminderSubmit} className="" >
                        <div className=" formgrid grid">
                            <div className="col-12 pt-2 pb-2">
                                <span style={{ color: 'red', fontWeight: 'bold', overflow: 'hidden', textAlign: 'center', alignItems: 'center' }}>{reminderBoxError}</span>
                                {/* <span>{reminderBoxError}</span> */}

                            </div>

                            <div className="col-12 pt-2">
                                <strong>Team Member : </strong>
                                {renderTeamMemberSelect()}

                            </div>


                            <div className="col-6 pt-2">
                                <strong>Quarter : </strong>
                                {renderSelectForQuarter()}

                            </div>

                            <div className="col-6 pt-2">
                                <strong>Year : </strong>
                                {renderYearSelect()}

                            </div>
                            <div className="col-12 pt-4">
                                <strong>Comments : </strong>
                                <textarea
                                    id="reason"
                                    value={reminderReason}
                                    onChange={(e) => setReminderReason(e.target.value)}
                                    className="p-inputtext p-component"
                                    style={{ width: '100%', height: '100px' }}
                                />
                            </div>
                            <div className="col-12 flex d-flex justify-content-center p-2" >
                                <Button label="Submit" type="submit" className="p-2 customSave-button" />
                            </div>

                        </div>
                    </form>
                </div>

            </Dialog>

            {/* // --------------------------------DELETE Box------------------------------------ */}

            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Delete Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>{projectDeletetitle}</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="delete-buttonx" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}

export default FormDashboard